import React, { useCallback, useEffect, useState } from "react";
import api from "../../../services/api";
import { getStripeJs } from "../../../services/stipe-js";
import { ContractAnimation } from "../../../shared/components/ContractAnimation";
import LoadingEditor from "../../editor/components/LoadingEditor";
import { LoadingFlex } from "../../login/pages/Login/styles";

import { Container } from "./styles";

interface ScreenProps {
  typeOfUser: string;
  setTypeOfUser: string;
  unlockScreen?: boolean;
  setUnlockScreen?: React.Dispatch<React.SetStateAction<boolean>>;
  isPayment?: boolean;
  setIsPayment?: React.Dispatch<React.SetStateAction<boolean>>;
}

const CheckoutScreen: React.FC<ScreenProps> = ({
  typeOfUser,
  setTypeOfUser,
  unlockScreen,
  setUnlockScreen,
  isPayment,
  setIsPayment
}) => {
  //unlock screen for mobile
  useEffect(() => {
    setUnlockScreen(true);
    setIsPayment(true);
  }, []);

  const [loading, setLoading] = useState(true);

  const handleSubscription = useCallback(async () => {
    if (typeOfUser) {
      if (typeOfUser === "Premium") {
        return;
      }

      try {
        const response = await api.post("stripe/create-session-payment-free");
        const { session_id } = response.data;
        const stripe = await getStripeJs();
        await stripe?.redirectToCheckout({ sessionId: session_id });
        setLoading(false);
      } catch (err) {
        console.log(err, "error!!!!");
        alert(err.message);
      }
    }
  }, [typeOfUser]);

  useEffect(() => {
    const autoLoad = async () => {
      if (typeOfUser === "Premium") {
        return;
      }

      try {
        await handleSubscription();
      } catch (err) {
        console.log(err);
        alert(err.message);
      }
    };

    if (typeOfUser !== null || typeOfUser === "Free") {
      autoLoad();
    }
  }, [typeOfUser]);

  return loading ? (
    <Container>
      <LoadingFlex>
        {/* <LoadingEditor /> */}
        <ContractAnimation />
      </LoadingFlex>
    </Container>
  ) : (
    <Container></Container>
  );
};

export default CheckoutScreen;
